import type { IWebVitalMetric } from '../types';
import type { IMetrics, IMetricsProvider } from './types';

export function createMetrics(provider: IMetricsProvider): IMetrics {
  return {
    increment(name, value = 1) {
      provider.increment(name, value);
    },
    gauge(name, value) {
      provider.gauge(name, value);
    },
    async measure(name, fn) {
      const markStart = `${name}:start`;
      const markEnd = `${name}:end`;
      const started = performance.now();

      try {
        performance.mark?.(markStart);
      } catch {
        // User Timing pode falhar em ambientes restritos
      }

      try {
        return await fn();
      } finally {
        const durationMs = performance.now() - started;
        try {
          performance.mark?.(markEnd);
          performance.measure?.(name, markStart, markEnd);
        } catch {
          // ignore
        }
        provider.timing(name, durationMs);
      }
    },
    recordWebVital(metric: IWebVitalMetric) {
      provider.recordWebVital?.(metric);
    },
  };
}
